import React, {Component, Fragment} from 'react'
import Helmet from "react-helmet";
import DeliveryPublicStep from '../../components/step/delivery-public-step'
import {Select, Button, Row, Col, Steps, message, Modal, Tabs, AutoComplete, Timeline} from 'antd'
import {baseUrl, getPublicTrails, getPublicOrderDetail, getPublicOrderList,} from '../../api'
import './track-query.less'
import {splitStr, pathStrSplit} from '../../utills/subStringUtill'
import logoImg from '../../assets/images/logo-1.png'
import {ReactBingmaps} from 'react-bingmaps'
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
import axios from 'axios'
import {getVehicleInfo} from '../../utills/common'
import {DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR, PLAN_DELIVERY_TYPE} from "../../utills/constants";

const {Option} = Select;
const {TabPane} = Tabs;
const typeItem = {
    'order': '订单号',
    'delivery': '物流单号',
    'boxNo': '集装箱号',
    'GPS': 'GPS设备号'
}

class TrackQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {

            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            visible: false,
            dataSource: [],
            rowId: 1,
            recordNo: '',
            type: 'order',
            order: {},
            orderNo: "",
            gpsNo: "",
            boxNo: '',
            carNo: '',
            factoryNo: '',
            recordNoData: [],
            currentStep: 0,
            destinationCity: '',
            mapData: [],
            exportShow: false,
            stepDescription: [],
            searchValue: "",
            selectMap: {},
            orderId: '',
            allData: [],
            placeholder: '请输入13位订单号',
            orderNodes: [],
            vehicleData: [],
        }
        this.pattern = /[A-Za-z]{4}\d{7}/;
        this.resize.bind(this);
    }

    componentWillMount() {
        let orderNo = this.props.match.params.orderNo
        let gpsNo = this.props.match.params.gpsNo
        this.init(orderNo, gpsNo)
        this.setState({
            searchValue: orderNo
        })
    }

    componentDidMount() {
        //添加监听
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        //移除监听
        window.removeEventListener('resize', this.resize);
    }

    resize = () => {
        this.setState({
            width: document.body.clientWidth
        })
    }
    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({
                activeId: id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    }

    getOrderShortFunc = async (id) => {
        let result = await getPublicOrderDetail(id)
        if (result.code === 200) {
            var data = result.data;
            data.start = data.originCountry + ' ' + data.originCity;
            data.destination = data.destinationCountry + ' ' + data.destinationCity;
            this.setState({
                order: data,
                orderId: data.orderId,
                destinationCity: '到达' + data.destinationCity,
                commitDt: data.commitDt,
                deliveryDt: data.collectDt,
            })
            if (data.routeType === 'N') {
                this.getOrderNodes(id);
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    }

    timer_two = (record, factoryCode) => setTimeout(
        () => {
            this.getPublicTrails(record, factoryCode)
        },
        2000
    );

    getPublicDelivery = (orderNo) => {
        axios.get(baseUrl + '/d/public/delivery', { // 配置对象
            params: {orderNo: orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.length > 0) {
                    const data = [];
                    let boxNo = '';
                    let factoryNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].id = i + 1;
                        result.data[i].key = i;
                        data.push(result.data[i]);
                        if (i === 1 && i < result.data.length - 1) {
                            break;
                        }
                    }
                    let i = 0, j = 0;
                    for (let o of result.data) {
                        if (o.boxNo) {
                            ++i;
                            boxNo = boxNo + o.boxNo + '，';
                        }
                        if (i === 2 && i < result.data.length - 1) {
                            boxNo = boxNo + '...';
                            break;
                        }
                    }
                    for (let o of result.data) {
                        if (o.factoryNo) {
                            ++j;
                            factoryNo = factoryNo + o.factoryNo + '，';
                        }
                        if (j === 2 && i < result.data.length - 1) {
                            factoryNo = factoryNo + '...';
                            break;
                        }
                    }
                    boxNo = splitStr(boxNo)
                    factoryNo = splitStr(factoryNo)
                    this.setState({
                        boxNo: boxNo,
                        factoryNo: factoryNo,
                        mapData: result.data
                    })
                    let {gpsNo, factoryCode} = this.state;
                    if (gpsNo == null || gpsNo == '') {
                        gpsNo = data[0].trailNo;
                        factoryCode = data[0].factoryCode;
                    } else {
                        //根据gps查询factoryCode
                        for (let o of result.data) {
                            if (o.trailNo === gpsNo) {
                                factoryCode = o.factoryCode;
                                break;
                            }
                        }
                    }
                    this.setState({
                        gpsNo, factoryCode, activeKey: gpsNo + ',' + factoryCode,
                    })
                    this.timer_two(gpsNo, factoryCode);
                    this.getRightOrderTrails(gpsNo, factoryCode)
                } else {
                    this.setState({
                        boxNo: "",
                        factoryNo: "",
                        mapData: []
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    exportModel = () => {
        let orderNo = this.state.order.orderNo
        window.location.href = baseUrl + "/d/public/opt/export?orderNo=" + orderNo;
    }

    getCheckExport = (orderNo) => {
        axios.get(baseUrl + '/d/public/checkExport', { // 配置对象
            params: {orderNo: orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                this.setState({
                    exportShow: true
                })
            } else if (result.code === 403) {
                this.setState({
                    exportShow: false
                })
            } else {
                this.setState({
                    exportShow: false
                })
                message.error(result.message)
                return false;
            }
        });
    }

    getPublicVehicle = (orderNo) => {
        axios.get(baseUrl + '/d/public/orderVehicle', { // 配置对象
            params: {orderNo: orderNo} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    /*let carNo = '';
                     for (let i = 0; i < result.data.length; i++) {
                     if (result.data[i].truckNo) { //车牌号
                     if (result.data[i].truckNo === '********') {
                     carNo = result.data[i].truckNo;
                     } else {
                     carNo = carNo + result.data[i].truckNo + '，';
                     }
                     }
                     if (i===1 && i < result.data.length - 1) {
                     if (carNo != '********') {
                     carNo = carNo+'...';
                     }
                     break;
                     }
                     }
                     carNo =splitStr(carNo)
                     this.setState({
                     carNo: carNo,
                     })*/
                    this.setState({
                        vehicleData: result.data,
                    })
                } else {
                    this.setState({
                        vehicleData: [],
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    getOrderNoList = async (type, recordNo) => {
        let trailNo = recordNo;
        if (recordNo.indexOf(',') > 0) {
            trailNo = recordNo.split(',')[0];
        }
        let result = await getPublicOrderList(type, trailNo)
        if (result.code === 200) {
            if (result.data && result.data.length > 0) {
                const orderNo = result.data[0].orderNo
                const gpsNo = result.data[0].trailNo
                this.jumpTo(orderNo, gpsNo, recordNo)
            } else {
                if (type === 'order') {
                    message.error('订单号有误')
                } else if (type === 'GPS') {
                    message.error('GPS设备号有误')
                } else {
                    message.error('集装箱号有误')
                }
            }

        } else {
            message.error(result.message)
        }

    }
    jumpTo = (orderNo, gpsNo, recordNo) => {
        let path = '/trackQuery/' + orderNo
        if (gpsNo && gpsNo != "") {
            path = path + "/" + gpsNo
        }

        this.setState(Object.assign(this.state, {
            searchValue: recordNo,
            recordNo: recordNo,
            selectMap: {[this.state.type]: recordNo},
            gpsNo: "",
            boxNo: '',
            carNo: '',
            factoryNo: '',
            recordNoData: [],
            currentStep: 0,
            destinationCity: '',
            mapData: [],
            stepDescription: [],
            allData: [],
        }));
        this.props.history.push(path)
        this.init(orderNo, gpsNo)
    }

    orderNoClick = () => {
        const {searchValue, type} = this.state;
        if (type && type === 'order' && (!searchValue || searchValue.length < 13)) {
            message.error(this.state.placeholder);
            return
        } else if (type && type === 'boxNo') {
            if (!searchValue || searchValue.length !== 11) {
                message.error(this.state.placeholder);
                return
            } else if (!this.pattern.test(searchValue)) {
                message.error('集装箱号前4位为字母,后7位为数字');
                return
            }
        } else if (type && type === 'GPS' && (!searchValue)) {
            message.error(this.state.placeholder);
            return
        }
        if (!searchValue) {
            message.error('请填写' + typeItem[type])
        } else {
            this.getOrderNoList(type, searchValue)
        }
    }

    init(orderNo, gpsNo) {
        if (orderNo) {
            this.setState({
                currentStep: null,
                commitDt: null,
                arriveDt: null,
                declareDt: null,
                passDt: null,
                transportDt: null,
                destinationCity: null,
                destinationDt: null,
            })
            this.getOrderShortFunc(orderNo)
            this.getPublicDelivery(orderNo)
            this.getPublicVehicle(orderNo)
            this.getCheckExport(orderNo)
        }
        this.setState({
            orderNo: orderNo,
            gpsNo: gpsNo,
            recordNo: orderNo,
            selectMap: {[this.state.type]: orderNo}
        });
    }


    getPublicTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getPublicTrails({trailNo, factoryCode, type: 'normal', orderNo: this.state.orderNo})
            console.log(result)
            if (result.code === 200 && result.data.length > 0) {
                let ret = []
                let ret2 = []
                result.data.forEach((item) => {
                    let address =
                        '位置:' + item.address + '<br/>' +
                        '设备号:' + item.trailNo + '<br/>' +
                        '到达时间:' + item.activeDt + '<br/>' +
                        '经度:' + item.longitude + '<br/>' +
                        '纬度:' + item.latitude + '<br/>' +
                        '温度(摄氏):' + (item.uTemperature != null ? item.uTemperature : '') + '<br/>' +
                        '电量(%):' + item.uBattery + '<br/>' +
                        '信号强度:' + item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "click",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        },
                        "pushPinAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        }
                    })
                    ret2.push([item.latitude, item.longitude])
                });
                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 2}},
                });
            } else if (result.code === 200) {
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    }
    handleClickItem = (des) => {
        if (des.sts === 'Y') {
            this.scrollInto("step" + des.id);
            this.setState({
                center: [des.latitude, des.longitude],
                regularPolygons: [
                    {
                        "center": [des.latitude, des.longitude],
                        "radius": 18,
                        "points": 6,
                        "option": {fillColor: "rgba(0,0,0,0.4)", strokeThickness: 2}
                    }
                ],
            });
        }
    };

    getRightOrderTrails = async (trailNo, factoryCode) => {
        if (trailNo) {
            let result = await getPublicTrails({trailNo, factoryCode, type: 'all', orderNo: this.state.orderNo})
            if (result.code === 200 && result.data.length > 0) {
                let description = []
                result.data.forEach(function (item) {
                    let sesObj = {
                        id: item.id,
                        sts: item.sts,
                        activeDt: item.activeDt,
                        address: item.address,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        uTemperature: item.uTemperature,
                        uSignalstrength: item.uSignalstrength

                    }
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription: description
                });
            } else if (result.code === 200) {
                this.setState({
                    stepDescription: []
                });
            } else {
                message.error(result.message)
            }
        }
    }

    //搜索type
    handleTypeChange = (value) => {
        if (value === 'order') {
            this.setState({
                placeholder: '请输入13位订单号'
            })
        } else if (value === 'boxNo') {
            this.setState({
                placeholder: '请输入11位集装箱号'
            })
        } else if (value === 'GPS') {
            this.setState({
                placeholder: '请输入GPS'
            })
        }
        this.setState({
            searchValue: this.state.selectMap[value]
        });
        this.setState({
            type: value
        })
    };

    hideModal = () => {
        this.setState({
            visible: false
        })
    }

    handleSelectChange = (value) => {
        console.log(value)
        this.setState({
            recordNo: value
        })
    };

    onOrderOk = () => {
        const {recordNo} = this.state
        this.getOrderShortFunc(recordNo)
        this.getPublicDelivery(recordNo)
        this.getPublicVehicle(recordNo)
        this.setState({
            recordNo: '',
            visible: false
        })
    }

    tabChange = (key) => {
        const trailNo = key.split(',')[0];
        const factoryCode = key.split(',')[1];
        this.setState({
            gpsNo: trailNo,
            factoryCode,
            activeKey: key,
        })
        this.getPublicTrails(trailNo, factoryCode)
        this.getRightOrderTrails(trailNo, factoryCode)
        let orderNo = this.state.orderNo
        let gpsNo = trailNo
        let path = '/trackQuery/' + orderNo
        if (gpsNo && gpsNo != "") {
            path = path + "/" + gpsNo
        }
        this.props.history.push(path)
    }
    steDescription = (obj) => {
        if (obj) {
            return <span>
                <span>{obj.activeDt}<br/></span>
                <span>{obj.address}<br/></span>
                <span>经度:{obj.longitude}<br/></span>
                <span>纬度:{obj.latitude}<br/></span>
                <span>温度(摄氏):{obj.uTemperature}<br/></span>
                <span>信号强度:{obj.uSignalstrength}</span>
            </span>
        }

    }
    renderOption = (item) => {
        let trailNo = item;
        let collectDt = '';
        if (item.indexOf(',') > 0) {
            trailNo = item.split(',')[0];
            collectDt = item.split(',')[1];
        }
        return (
            <Option key={item} text={trailNo} code={collectDt}>
                <div className="global-search-item">
        <span className="global-search-item-desc">
         {trailNo} {collectDt}
        </span>
                </div>
            </Option>
        );
    }
    onChange = value => {
        this.setState({
            searchValue: value,
            recordNo: value
        });
        this.getOrderAutoList(this.state.type, value)
    }
    //option为renderOption中的option对象
    onSelect = (value, option) => {
        let type = this.state.type;
        let orderNo = '';
        let gpsNo = '';
        if (type == "order") {
            type = "orderNo"
        } else if (type == "boxNo") {
            type = "boxNo"
        } else if (type == "GPS") {
            type = "trailNo"
        }
        for (let i of this.state.allData) {
            if (type === 'trailNo' && option) {
                if (i[type] == option.props.text && i.collectDt === option.props.code) {
                    orderNo = i["orderNo"];
                    gpsNo = i["trailNo"];
                    break
                }
            } else if (i[type] == value) {
                orderNo = i["orderNo"];
                gpsNo = i["trailNo"];
                break
            }
        }
        this.jumpTo(orderNo, gpsNo, value)
        // let path = '/trackQuery/'+orderNo
        // if(gpsNo && gpsNo!=""){
        //     path = path+"/"+gpsNo
        // }
        // console.log(path)
        // this.props.history.push(path)
        // this.init(orderNo,gpsNo)
        // this.setState({
        //     searchValue:value,
        //     recordNo:value
        // })
        // this.setState({
        //     selectMap:{[this.state.type]:value}
        // });
    }
    getOrderAutoList = async (type, recordNo) => {
        if (type && type === 'order' && (!recordNo || recordNo.length < 13)) {
            this.setState({
                dataSource: []
            })
            return
        } else if (type && type === 'boxNo' && (!recordNo || recordNo.length < 11)) {
            this.setState({
                dataSource: []
            })
            return
        } else if (type && type === 'GPS' && (!recordNo)) {
            this.setState({
                dataSource: []
            })
            return
        } else if (!recordNo || recordNo.length < 2) {
            this.setState({
                dataSource: []
            })
            return
        }
        let result = await getPublicOrderList(type, recordNo)
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    allData: result.data
                })
                let newType = type
                if (type == "order") {
                    newType = "orderNo"
                } else if (type == "boxNo") {
                    newType = "boxNo"
                } else if (type == "GPS") {
                    newType = "trailNo"
                }
                let dataSource = []
                for (let i of result.data) {
                    if (i[newType] != undefined) {
                        if (newType === "trailNo") {
                            dataSource.push(i[newType] + ',' + i.collectDt)
                        } else {
                            dataSource.push(i[newType])
                        }
                    }
                }
                const data = new Set(dataSource);
                this.setState({
                    dataSource: Array.from(data)
                })
            }
        } else {
            this.setState({
                dataSource: []
            })
        }
    }
    setColletDt = (date) => {
        if (date) {
            this.setState({
                deliveryDt: date
            })
        }

    }
    getOrderNodes = async (orderNo) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/d/public/yg/orderNodes", {orderNo});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeIOType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    }
    dataStars = (value, subLen) => {
        if (value != null) {
            if (value.length >= subLen) {//原字符串的内容不少于星号数
                let stars = '';
                for (let i = 0; i < subLen; i++) {
                    stars += '*'
                }
                return value.substr(0, value.length - subLen) + stars;
            } else {//原字符串的内容少于星号数，返回原字符串length个星号
                let stars = '';
                for (let i = 0; i < value.length; i++) {
                    stars += '*'
                }
                return stars
            }
        } else {
            return ''
        }
    }

    render() {
        const {
            recordNo, recordNoData, visible, stepDescription, mapData, exportShow, vehicleData,
            order, width,
        } = this.state;
        return (
            <div className='track-query'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                />
                <div className="track-query-header">
                    <div className="track-query-header-content content1190">
                        <img src={logoImg} alt="logoImg"/>
                        <span className='header-line'></span>
                        <span className='header-title'>跨境货运物流轨迹查询</span>
                        <a href='http://55train.com'>
                            官网首页
                        </a>
                    </div>
                </div>
                <div className="track-query-content content1190">
                    {/*<div className="track-query-content-search">
                     <Select defaultValue={type}  onChange={this.handleTypeChange}>
                     <Option value="order">订单号</Option>
                     <Option value="boxNo">集装箱号</Option>
                     <Option value="GPS">GPS设备号</Option>
                     </Select>
                     <AutoComplete
                     dataSource={dataSource.map(this.renderOption)}
                     optionLabelProp="text"
                     style={{ width:"80%",flex:1}}
                     onChange ={this.onChange}
                     onSelect={this.onSelect}
                     value={searchValue}
                     allowClear={true}
                     backfill={true}
                     placeholder={this.state.placeholder}
                     defaultActiveFirstOption={true}
                     />
                     <Button   onClick={this.orderNoClick}>查询</Button>
                     </div>*/}
                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType) && order.subType === 'B' ?
                        <Fragment>
                            <div className="track-info-details delivery-box">
                                <div className="delivery-title">
                                    订单详情
                                </div>
                                <Row className='track-info-item'>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>订单编号 : </span>
                                        <span>{order.orderNo}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>揽收单位: </span>
                                        <span>{order.entName}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>起运地 : </span>
                                        <span>{order.start}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>清关地 : </span>
                                        <span>{order.customsClearanceCountry} {order.customsClearanceCity}</span>
                                    </Col>
                                </Row>
                                <Row className='track-info-item'>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>目的地 : </span>
                                        <span>{order.destination}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>提货时间 : </span>
                                        <span>{this.state.deliveryDt}</span>
                                    </Col>
                                    <Col span={12} xs={24} md={12}>
                                        <span className='label'>厂封号 : </span>
                                        <span>{this.state.factoryNo}</span>
                                    </Col>
                                </Row>
                            </div>
                        </Fragment> :
                        <Fragment>
                            <div className="track-info-details delivery-box">
                                <div className="delivery-title">
                                    订单详情
                                </div>
                                <Row className='track-info-item'>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>订单编号 : </span>
                                        <span>{order.orderNo}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>揽收单位 : </span>
                                        <span>{order.entName}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>起运地 : </span>
                                        <span>{order.start}</span>
                                    </Col>
                                    {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                                        <Col span={6} xs={24} md={6}>
                                            <span className='label'>启运机场 : </span>
                                            <span>{order.airStartCountry} {order.airStartCity}</span>
                                        </Col> : null}
                                    {DELIVERY_TYPE_MIX.hasOwnProperty(order.deliveryType) ?
                                        <Col span={6} xs={24} md={6}>
                                            <span
                                                className='label'>{PLAN_DELIVERY_TYPE.hasOwnProperty(order.deliveryType) || order.deliveryType === 'D' ? '目的站' : '转关地'}
                                                : </span>
                                            <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                                        </Col> : null}
                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType) ?
                                        <Col span={6} xs={24} md={6}>
                                            <span className='label'>清关地 : </span>
                                            <span>{order.customsClearanceCountry} {order.customsClearanceCity}</span>
                                        </Col> : null}
                                </Row>
                                <Row className='track-info-item'>
                                    {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                                        <Col span={6} xs={24} md={6}>
                                            <span className='label'>目的机场 : </span>
                                            <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                                        </Col> : null}
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>目的地 : </span>
                                        <span>{order.destination}</span>
                                    </Col>
                                    {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ? null :
                                        <Col span={6} xs={24} md={6}>
                                            <span className='label'>还箱地 : </span>
                                            <span>{order.boxReturnStation}</span>
                                        </Col>}
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>提货时间 : </span>
                                        <span>{this.state.deliveryDt}</span>
                                    </Col>
                                    <Col span={6} xs={24} md={6}>
                                        <span className='label'>集装箱号 : </span>
                                        <span>{this.state.boxNo}</span>
                                    </Col>
                                </Row>
                                <Row className='track-info-item'>
                                    <Col span={12} xs={24} md={12}>
                                        <span className='label'>厂封号 : </span>
                                        <span>{this.state.factoryNo}</span>
                                    </Col>
                                </Row>
                            </div>
                        </Fragment>}
                    <div className="track-info-details delivery-box">
                        <div className="delivery-title">
                            车辆信息
                        </div>
                        {vehicleData.map(t => {
                            return <Row className='track-info-item'>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>车牌号 : </span>
                                    <span>{getVehicleInfo(t.truckNo, t.hangNo)}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>司机姓名 : </span>
                                    <span>{this.dataStars(t.name, 1)}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>手机号码 : </span>
                                    <span>{this.dataStars(t.phone, 4)}</span>
                                </Col>
                                <Col span={6} xs={24} md={6}>
                                    <span className='label'>身份证号码 : </span>
                                    <span>{this.dataStars(t.identification, 4)}</span>
                                </Col>
                            </Row>
                        })}
                    </div>
                </div>
                <div className='delivery-details delivery-box content1190'>
                    <div className="delivery-title">
                        物流状态
                        {exportShow ? <Button type="primary" style={{float: "right", top: '10px'}}
                                              onClick={this.exportModel}>导出</Button> : null}
                    </div>
                    <div className='tract-step-info'>
                        {order.routeType === 'N' ?
                            <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeIOType}
                                               readOnly={true} loading={this.state.loading}
                                               reload={this.getOrderNodes}/>
                            : <DeliveryPublicStep orderNo={order.orderNo} {...this.props}
                                                  setColletDt={this.setColletDt}/>}
                    </div>
                </div>
                <div className='delivery-details delivery-box content1190'>
                    <div className="delivery-title">
                        物流轨迹
                    </div>
                    {
                        mapData ? <Tabs activeKey={this.state.activeKey} type="card" style={{marginTop: '10px'}}
                                        onChange={this.tabChange}>
                            {mapData.map(t => {
                                return t.trailNo ?
                                    <TabPane tab={t.trailNo} key={t.trailNo + ',' + t.factoryCode}></TabPane> : ''
                            })}
                        </Tabs> : null
                    }
                    <div className='delivery-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={6}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins}
                                regularPolygons={this.state.regularPolygons}
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                        onClick={() => this.handleClickItem(des)}
                                        style={this.state.activeId === ("step" + des.id) ? {
                                            color: "#2975d5",
                                            paddingTop: 3
                                        } : (des.sts !== 'N' ? {
                                            color: "rgba(0, 0, 0, 0.9)",
                                            paddingTop: 3
                                        } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.steDescription(des)}</p>
                                    </Timeline.Item>
                                ))}
                            </Timeline> : null}
                        </div>
                    </div>
                </div>
                <Modal
                    title="请选择订单号"
                    visible={visible}
                    onCancel={this.hideModal}
                    footer={[<Button onClick={this.onOrderOk} type='primary'>确定</Button>]}
                >
                    <Select style={{width: '300px'}} defaultValue={recordNo} onChange={this.handleSelectChange}>
                        {recordNoData.map(c => (
                            <Option value={c} key={c}>{c}</Option>
                        ))}
                    </Select>
                </Modal>
            </div>
        )
    }
}

export default TrackQuery

